module.exports = __webpack_public_path__ + "img/49.689c208e.png";